// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/:domain\",\"regex\":\"^/([^/]+)/([^/]+)$\",\"paramNames\":[\"locale\",\"domain\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/editor-preview/:movieId\",\"regex\":\"^/([^/]+)/editor-preview/([^/]+)$\",\"paramNames\":[\"locale\",\"movieId\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[\"/:locale/:domain\"]}";globalThis["_sentryNextJsVersion"] = "16.3.1";import * as Sentry from '@sentry/nextjs';

import { ANALYSIS_COOKIES_PROPERTY_NAME } from '@cineamo/ui/src/constants/cookie-constants';

import { cookieStorage } from '@cineamo/ui/src/helpers/cookie-helper';

import '@cineamo/ui/src/polyfills';

import { reportSwallowedApiFailures } from '@cineamo/composables/src/sentry/api-error-reporting';

import initSentryClient from '@/utils/sentry/initSentryClient';

// Failures the `orNull`/`orFalse`/`orError` fallbacks swallow still reach Sentry (5xx and network only).
reportSwallowedApiFailures('client');

// CIN-14630: Sentry is NOT initialised unconditionally on import — it contacted
// `*.ingest.us.sentry.io` on page load, before the consent banner was shown. A returning visitor
// who already consented gets Sentry from the very first line of client code, so early errors are
// still captured; everyone else waits for ConsentGatedSentry to observe a consent decision.
// The editor preview is staff and distributors working, not visitors: no Sentry user tracking there.
const isEditorPreview = window.location.pathname.includes('/editor-preview/');
if (!isEditorPreview && cookieStorage.getItem(ANALYSIS_COOKIES_PROPERTY_NAME) === true) {
    initSentryClient();
}

// Safe to export unconditionally: the Sentry API no-ops while no client is registered.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
